var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { MPInstancesHub } from "@/api/RequestAxios/RequestAxiosHub";
import { packQueryParams, stringifyQueryParams } from "../utils";
import { UIModelPartnerChannel, UIModelPartnerChannels, } from "./partnerChannels.model";
import { unpackPartnerChannel, unpackPartnerChannels, packPartnerChannelFromPipe, unpackPartnerChannelFromSubmit, packPartnerChannelFromSubmit, packPartnerChannelFromMigrate, unpackPartnerChannelFromMigrate, } from "./partnerChannels.mapper";
import { unpackChannel } from "../channels/channels.mapper";
var partnerChannelsURL = function (_a) {
    var partnerId = _a.partnerId;
    return "/partners/".concat(partnerId, "/channels");
};
var partnerChannelsV2URL = function () { return "/channels/info/contact_data"; };
var partnerChannelURL = function (_a) {
    var partnerId = _a.partnerId, channelId = _a.channelId;
    return "/partners/".concat(partnerId, "/channels/").concat(channelId);
};
var partnerChannelCreateFlow = function (_a) {
    var partnerId = _a.partnerId;
    return "/partners/".concat(partnerId, "/channels_combined");
};
var partnerChannelMigrateUrl = function (_a) {
    var partnerId = _a.partnerId;
    return "/partners/".concat(partnerId, "/migrate_channel");
};
var partnerChannelWebhookUrl = function (_a) {
    var partnerId = _a.partnerId, appId = _a.appId;
    return "/partners/".concat(partnerId, "/apps/").concat(appId, "/webhook");
};
export var getPartnerChannels = function (_a, queryParams) {
    var partnerId = _a.partnerId;
    return __awaiter(void 0, void 0, Promise, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.get(partnerChannelsURL({ partnerId: partnerId }), {
                        params: queryParams && packQueryParams(queryParams),
                        paramsSerializer: stringifyQueryParams,
                    })];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, new UIModelPartnerChannels(unpackPartnerChannels(data))];
            }
        });
    });
};
export var getPartnerChannel = function (_a) {
    var partnerId = _a.partnerId, channelId = _a.channelId;
    return __awaiter(void 0, void 0, Promise, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.get(partnerChannelURL({ partnerId: partnerId, channelId: channelId }))];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, new UIModelPartnerChannel(unpackPartnerChannel(data))];
            }
        });
    });
};
export var getPartnerChannelsV2 = function () { return __awaiter(void 0, void 0, void 0, function () {
    var data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(partnerChannelsV2URL())];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, data];
        }
    });
}); };
export var addPartnerChannelFromPipe = function (_a, payload) {
    var partnerId = _a.partnerId;
    return __awaiter(void 0, void 0, Promise, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(partnerChannelCreateFlow({ partnerId: partnerId }), packPartnerChannelFromPipe(payload))];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, unpackChannel(data)];
            }
        });
    });
};
export var addPartnerChannelFromSubmitWaba = function (_a, payload) {
    var partnerId = _a.partnerId;
    return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(partnerChannelCreateFlow({ partnerId: partnerId }), packPartnerChannelFromSubmit(payload))];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, unpackPartnerChannelFromSubmit(data)];
            }
        });
    });
};
export var addPartnerChannelFromMigrateWaba = function (_a, payload) {
    var partnerId = _a.partnerId;
    return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(partnerChannelMigrateUrl({ partnerId: partnerId }), packPartnerChannelFromMigrate(payload))];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, unpackPartnerChannelFromMigrate(data)];
            }
        });
    });
};
export var updateChannelWebhookUrl = function (_a) {
    var partnerId = _a.partnerId, appId = _a.appId, url = _a.url;
    return __awaiter(void 0, void 0, Promise, function () {
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(partnerChannelWebhookUrl({ partnerId: partnerId, appId: appId }), { url: url })];
                case 1:
                    _b.sent();
                    return [2 /*return*/];
            }
        });
    });
};
export var getChannelWebhookUrl = function (_a) {
    var partnerId = _a.partnerId, appId = _a.appId;
    return __awaiter(void 0, void 0, Promise, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.get(partnerChannelWebhookUrl({ partnerId: partnerId, appId: appId }))];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    });
};
//# sourceMappingURL=data:application/json;base64,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